import { HiLockClosed } from 'react-icons/hi';
import styled from 'styled-components';

import { ProjectSummary } from 'types';
import useProjectCard from './hooks/useProjectCard';
import ProjectCardMenu from './components/ProjectCardMenu';
import ProjectInfo from './components/ProjectCardInfo';
import Thumbnail from 'pages/Editor/sections/Flow/components/Thumbnail';

const Container = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.global.bgColor};
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  box-shadow: 0px 0px 10px -6px #a0a0a0;

  &:hover {
    transform: scale(1.02);

    .menu-icon {
      display: flex;
    }

    outline: 2px solid ${(props) => props.theme.global.mainColor};
  }
`;

const ThumbnailView = styled.div`
  display: flex;
  height: 220px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;

const LockedIcon = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  top: 8px;
  left: 8px;
  color: ${(props) => props.theme.global.lightTextColor};
  z-index: 11;
`;

interface ProjectCardProps {
  project: ProjectSummary;
  projectsRefetch: () => void;
}

const ProjectCard = ({ project, projectsRefetch }: ProjectCardProps) => {
  const { url, onCopyButtonClick, onDeleteButtonClick, onMenuButtonClick } = useProjectCard({
    project,
    projectsRefetch,
  });
  return (
    <>
      <Container as="a" href={url} target="_blank">
        {project.projectScope === 'Private' && (
          <LockedIcon>
            <HiLockClosed />
          </LockedIcon>
        )}
        <ProjectCardMenu
          onCopyButtonClick={onCopyButtonClick}
          onDeleteButtonClick={onDeleteButtonClick}
          onMenuButtonClick={onMenuButtonClick}
        />
        <ThumbnailView>
          <Thumbnail model={project.model} modelDirection={project.direction} />
        </ThumbnailView>
        <ProjectInfo project={project} />
      </Container>
    </>
  );
};

export default ProjectCard;
